import script from "./GooglePage.vue?vue&type=script&setup=true&lang=js"
export * from "./GooglePage.vue?vue&type=script&setup=true&lang=js"

import "./GooglePage.vue?vue&type=style&index=0&id=5f0e3edc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0e3edc"]])

export default __exports__